import { MARQUEE_ITEMS } from "../data/content";

const Row = () => (
    <div className="flex shrink-0 items-center">
        {MARQUEE_ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="px-8 font-serif italic text-2xl sm:text-3xl text-zinc-600 whitespace-nowrap">
                    {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#d6c68e]/70" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#070c18]/70 py-6">
        <div className="marquee-track flex w-max">
            <Row />
            <Row />
        </div>
    </div>
);
